import { ReactElement } from 'react';

export function HomePage(): ReactElement {
	return <div>This is the home page</div>;
}
